import type { IconSvgObject } from './types';

const ArrowUp02Icon: IconSvgObject = [
  ["path", { d: "M18 11L12 5L6 11M12 5.5V19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default ArrowUp02Icon;
